import { CompanyAdminDashboardData } from '../../../../pages/company/Overview/types';
import { API_VERSION } from '../../../../util/constants';
import { get } from '../../../../util/httpService';
import { normalizeSnakeCase } from '../../../../util/util';

export const getCompanyAdminDashboardData = async (): Promise<CompanyAdminDashboardData> => {
  let endpoint = `${API_VERSION}/dashboard/company-admin`;
  const dashboard = (await get(endpoint)) as CompanyAdminDashboardData;

  dashboard.lineChart = dashboard.lineChart.map((item) => {
    item.dataset.forEach((datasetItem) => {
      datasetItem.labelKey = `GLOBAL.${normalizeSnakeCase(datasetItem.label)}`;
    });
    return item;
  });

  return dashboard;
};

export const getOverviewChartData = async () => {
  let endpoint = `${API_VERSION}/dashboard`;
  const overviewData = await get(endpoint);
  return overviewData;
};

export const getRunningProcessData = async () => {
  let endpoint = `${API_VERSION}/process-calender`;
  const overviewData = await get(endpoint);
  return overviewData;
};
